<div id="{{id}}">
  <field-item item="criteriaFormModel">
    <field-select name="{{name}}" {options}="selectOptions" 
      option-none="true" option-none-key="_All"></field-select>
  </field-item>
</div>